// src/components/ui/Button.jsx — FINAL FIXED VERSION
import React from 'react';
import LoadingSpinner from '../../common/LoadingSpinner';

export default function Button({
  type = 'button',
  variant = 'primary',
  icon: IconComponent,  // ← Rename to IconComponent
  children,
  onClick,
  className = '',
  disabled = false,
  loading = false,
  ...props
}) {
  const baseStyles = `inline-flex items-center justify-center font-semibold rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all`;
  const sizeStyles = `px-6 py-3 text-base`; // improved
  const variantStyles = {
    primary: `bg-primary text-white hover:bg-primary/90 focus:ring-primary/30`,
    secondary: `bg-secondary text-white hover:bg-secondary/90`,
    outline: `border-2 border-primary text-primary hover:bg-primary/5`,
    ghost: `text-primary hover:bg-primary/5`,
    danger: `bg-red-600 text-white hover:bg-red-700`,
    white: `bg-white text-white hover:bg-red-700`,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${sizeStyles} ${variantStyles[variant]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {/* THIS IS THE FIX */}
      <span>{children}</span>
      {IconComponent && <IconComponent className="nl-3 mr-2" size={20} />} {loading && <LoadingSpinner color='white'/>}
    </button>
  );
}